"use strict";
/**
 * API: Controller Organigrama
 * Fitxer: PendAPI
 * Autor: Jordi Riu Amblàs
 * Data: 31/05/2017
 * (c) Ajuntament de Manresa - mai 2017 - Departament de Sistemes d'Informació
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AppApi_1 = require("./AppApi"); // const urlBase: string = 'localhost:2073/api';


var urlBase = 'http://wfserver/gestioPrioritats.api/api';
var controller = 'RhuOrga/';

var OrgaApi =
/** @class */
function () {
  function OrgaApi(appState) {
    this.appState = appState;
    this.req = new AppApi_1.default(this.appState, {
      urlBase: appState.config.urlBaseOrgaApi || process.env.REACT_APP_URL_API_ORGANIGRAMA || urlBase,
      urlBD: appState.config.bd
    });
  }

  OrgaApi.prototype.getDadesTreballador = function (idEmpresa, idTreballador) {
    return this.req.getRequest(controller + 'GetDadesTreballador', {
      idEmpresa: idEmpresa,
      idTreballador: idTreballador
    });
  };

  OrgaApi.prototype.getDadesOrganigrama = function (codiDep) {
    return this.req.getRequest(controller + 'GetDadesOrganigrama', {
      codiDep: codiDep
    });
  };

  return OrgaApi;
}();

exports.default = OrgaApi;